import Tag, { type TagProps } from '@cobliteam/ui/components/Tag';

import { ReactComponent as GravityIcon } from '../../../icons/gravity/gravity.svg';

const Moderate = (props: TagProps) => {
  return <Tag label={props.label || 'Média'} color='warning' icon={<GravityIcon />} {...props} />;
};

const Severe = (props: TagProps) => {
  return <Tag label={props.label || 'Grave'} color='danger' icon={<GravityIcon />} {...props} />;
};

const Gravest = (props: TagProps) => {
  return <Tag label={props.label || 'Gravíssima'} color='danger-dark' icon={<GravityIcon />} {...props} />;
};

export default {
  Moderate,
  Severe,
  Gravest,
};
